import React from 'react';
import TourMenu from '../TourMenu/TourMenu.react';
import HelpButton from '../HelpButton/HelpButton.react.old';
import {PropTypes} from 'prop-types';
import './TourPanel.less';
import LocaleContext from '../../../../Contexts/Locale/Context';

class TourPanel extends React.Component {
    static propTypes = {
        onClickHelp: PropTypes.func.isRequired,
        tour: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
        overlay: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
        mediaMatches: PropTypes.shape({
            screenXsMax: PropTypes.boolean,
        }),
    };

    render() {
        let showHelpButton = !this.props.overlay.get('showOnboardingGuide');
        return (
            <LocaleContext.Consumer>
                {(getTranslation) => (
                    <div className="TourPanelContainer">
                        <div className={'TourPanelFragment'}>
                            <TourMenu {...this.props} mediaMatches={this.props.mediaMatches} />
                            {showHelpButton && (
                                <HelpButton
                                    helpText={getTranslation('messages', 'onboarding.help')}
                                    mediaMatches={this.props.mediaMatches}
                                    onClick={this.props.onClickHelp}
                                />
                            )}
                        </div>
                    </div>
                )}
            </LocaleContext.Consumer>
        );
    }
}

export default TourPanel;
